import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26b42ed6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout min-h-screen w-screen overflow-hidden auto-rows-fr" }
const _hoisted_2 = { class: "flex items-center space-x-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Home", -1))
const _hoisted_4 = { class: "flex items-center space-x-2 text-black" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Back to home page", -1))
const _hoisted_6 = { class: "px-4 py-6 sm:p-12 content" }
const _hoisted_7 = { class: "block md:hidden" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Thank you 🙏")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "We are verifying your contribution carefully", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Press \"View activity\" to see the donation status", -1))

import NavSidebar from '@/components/NavSidebar.vue';
import TopHeader from '@/components/TopHeader.vue';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { Icon } from '@iconify/vue';
import ModalWallet from '@/components/Modals/ModalWallet.vue';
import MenuAuthenticatedUser from '@/components/MenuAuthenticatedUser.vue';
import BaseButton from '@/components/Base/BaseButton.vue';
import LandingFooter from '@/components/Landing/LandingFooter';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

const showDonated = ref<boolean>(false);

const viewActivity = () => {
  showDonated.value = false;
  router.push('/activity');
};

const meta_des = document.querySelector('meta[property="og:description"]');
const meta_des2 = document.querySelector('meta[name="description"]');
const meta_dfb = document.querySelector('meta[name="keywords"]');

if (meta_des && meta_des2 && meta_dfb) {
  meta_des.setAttribute(
    'content',
    'The future of our planet and the chance to save itis in our hands.'
  );
  meta_des2.setAttribute(
    'content',
    'The future of our planet and the chance to save itis in our hands.'
  );

  meta_dfb.setAttribute(
    'content',
    'The future of our planet and the chance to save itis in our hands.'
  );
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TopHeader, { class: "header" }, {
        left: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: "/landing",
            class: "sm:hidden",
            "data-testid": "back-to-home"
          }, {
            default: _withCtx(() => [
              _createVNode(BaseButton, {
                "color-scheme": "white",
                outlined: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(Icon), {
                      icon: "bx:bx-home-alt",
                      class: "text-xl"
                    }),
                    _hoisted_3
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/landing",
            class: "hidden sm:inline-block",
            "data-testid": "back-to-home"
          }, {
            default: _withCtx(() => [
              _createVNode(BaseButton, { "color-scheme": "white" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(Icon), {
                      icon: "akar-icons:chevron-left",
                      class: "text-xl"
                    }),
                    _hoisted_5
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        right: _withCtx(() => [
          _createVNode(ModalWallet, null, {
            default: _withCtx(() => [
              _createVNode(MenuAuthenticatedUser)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(NavSidebar, { class: "sidebar" }),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_view)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_unref(LandingFooter))
    ]),
    _createVNode(_component_BaseModal, {
      modelValue: showDonated.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showDonated).value = $event)),
      "cancel-text": "Close",
      "confirm-text": "View activity",
      "modal-style": "confirm",
      onConfirm: viewActivity
    }, {
      title: _withCtx(() => [
        _hoisted_8
      ]),
      default: _withCtx(() => [
        _hoisted_9,
        _hoisted_10
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})